import { hbs } from 'ember-cli-htmlbars';
import { userChangeVerificationCodeAction, userClickResendCodeAction, userClickVerifyAction } from '@banking/ui/workflows/common/two-factor';
import { workflowComponent } from '@banking/ui/services/card-management/cancel-card-modal';
const template = hbs`
  <Banking::TwoFactor::VerifyCode
    @phoneNumber={{this.phoneNumber}}
    @errorMessage={{this.errorMessage}}
    @isButtonLoading={{this.isButtonLoading}}
    @onValueChange={{this.onValueChange}}
    @onNextButtonClick={{this.onNextButtonClick}}
    @onResendCodeClick={{this.onResendCodeClick}}
  />`;
const mapStateToProps = state => {
  const twoFactorState = state.twoFactor;
  return {
    phoneNumber: twoFactorState.phoneNumber,
    // default to null because market-field will show error with empty string error message
    errorMessage: twoFactorState.verificationCodeError || null,
    isButtonLoading: twoFactorState.toggleButtonLoading
  };
};
const mapActionsToProps = () => ({
  onValueChange: userChangeVerificationCodeAction,
  onNextButtonClick: userClickVerifyAction,
  onResendCodeClick: userClickResendCodeAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);